
const m = window.require("embercom/lib/inflector");
if (m.default && !m.__esModule) {
  m.__esModule = true;
}
module.exports = m;
